'use strict';

/**
 * The helpers exported in this file are used to calculate
 * the origin details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 *
 */

const sharedHelpers = require('./detailsSharedLogic');

/**
 * @param {object} item           - Bunsen Item model
 * @returns {object} originModel  - the first origin attribute model of an item
 */
function getPlaceOfOriginModel(item) {
    const origin = item.get('attributes.origin');
    let originModel;

    if (origin) {
        originModel = origin.first();
    }

    return originModel;
}

module.exports = {
    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getPlaceOfOrigin: function(config) {
        return sharedHelpers.getSingleValueWithoutLink(config, 'classification.countryOfOrigin');
    },

    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getPlaceOfOriginFurniture: function(config) {
        const { item, links } = config;
        const origin = getPlaceOfOriginModel(item);

        return sharedHelpers.addToContents({
            model: origin,
            modelKey: 'value',
            links,
            linkKey: 'placeOfOrigin',
        });
    },
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/helpers/detailsOrigins.es.js